import { t } from 'i18next';
import { AccountTypes } from '../../components/changeUser/accountTypes.enum';
import { LoggedInUser } from '../../state/helperServices/auth/auth.interfaces';
import {
  Role,
  User,
} from '../../state/reduxRepositories/users/users.interfaces';

interface ValidationResult {
  valid: boolean;
  errorMessage?: string;
  errorField?: string;
}

export function validateNewUser(userRecord: Partial<User>): ValidationResult {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!userRecord.email)
    return {
      valid: false,
      errorMessage: t('EMAIL_REQUIRED').toString(),
      errorField: 'email',
    };

  if (!emailRegex.test(userRecord.email.toLowerCase())) {
    return {
      valid: false,
      errorMessage: t('VALID_EMAIL_REQUIRED').toString(),
      errorField: 'email',
    };
  }

  if (!userRecord.firstName) {
    return {
      valid: false,
      errorMessage: t('SIGN_UP_VALIDATE_FIRST_NAME').toString(),
      errorField: 'firstName',
    };
  }

  if (!userRecord.lastName) {
    return {
      valid: false,
      errorMessage: t('SIGN_UP_VALIDATE_LAST_NAME').toString(),
      errorField: 'lastName',
    };
  }

  return { valid: true };
}

export function checkIfUserHasAdminRole(logInUser: LoggedInUser | undefined) {
  return logInUser?.role.includes(Role.ADMIN);
}

export function hasPermissionToEditUserForm(
  logInUser: LoggedInUser | undefined,
) {
  if (checkIfUserHasAdminRole(logInUser)) {
    return true;
  }

  return false;
}

export function hasPermissionUpdateAdminFlags(
  logInUser: LoggedInUser | undefined,
  currentUserId: string | undefined,
) {
  if (checkIfUserHasAdminRole(logInUser) && logInUser?.id !== currentUserId) {
    return false;
  }
  return true;
}

export const getUserRole = (role: string): string => {
  let userRole = '';
  switch (role) {
    case Role.USER:
      userRole = Role.USER;
      break;
    case Role.ADMIN:
      userRole = Role.ADMIN;
      break;
    case Role.MD:
      userRole = Role.MD;
      break;
    default:
      break;
  }

  return userRole;
};

export const getRoleList = (loggedInUser: LoggedInUser) => {
  const rolesList = [];
  if (loggedInUser.accountType === AccountTypes.Clinic) {
    rolesList.push({ value: Role.MD, text: t('MD') });
  }
  if (loggedInUser.accountType === AccountTypes.Org) {
    rolesList.push({ value: Role.USER, text: t('USER') });
  }

  if (hasPermissionToEditUserForm(loggedInUser)) {
    rolesList.push({ value: Role.ADMIN, text: t('ADMIN') });
  }
  return rolesList;
};
